export default {
  strict: true,
  namespaced: true,
  state: {
    creditCard: {
      owner: '',
      card: '',
      expiration: '',
      cvv: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      country: 'US'
    }
  },
  mutations: {
    setCreditCardData (state, data) { state.creditCard[data.field] = data.value }
  },
  sharedMutations: []
}
    


// WEBPACK FOOTER //
// ./src/store/corporate/credit-card.js